import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    dialogTitle: {
        padding: '12px 0 0 24px',
        minWidth: '300px'
    },
    dialogContent: {
        maxHeight: '400px',
        '& .MuiDialog-paperWidthSm': {
            maxHeight: '400px'
        }
    },
    closeBtn: {
        position: 'absolute',
        right: 0
    },
    file: {
        position: 'relative',
        margin: '16px 0 12px',
        padding: '12px',
        borderRadius: '8px',
        background: '#EFEFEF'
    },
    iconBtn: {
        position: 'absolute',
        right: 0,
    },
    title: {
        fontWeight: 'bold',
    },
}));

export default useStyles;
